import { render, staticRenderFns } from "./TextBlockSettings.vue?vue&type=template&id=5842106b&scoped=true"
import script from "./TextBlockSettings.vue?vue&type=script&lang=ts"
export * from "./TextBlockSettings.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5842106b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5842106b')) {
      api.createRecord('5842106b', component.options)
    } else {
      api.reload('5842106b', component.options)
    }
    module.hot.accept("./TextBlockSettings.vue?vue&type=template&id=5842106b&scoped=true", function () {
      api.rerender('5842106b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/label-layout-editor/TextBlockSettings.vue"
export default component.exports